import { AirportCodes } from '../../../../types/airports';
import { getMobileOperatingSystem } from '../../../../utils/getMobileOperatingSystem';
import { IPoiPosition } from '../../ui/ParkingCard';

const IAH_COORDINATES = {
	latitude: 29.9931104,
	longitude: -95.3442004,
};

const HOU_COORDINATES = {
	latitude: 29.6459187,
	longitude: -95.27947,
};

export const getParkingMapDirectionsUrl = (
	airportCode: AirportCodes,
	position?: IPoiPosition,
) => {
	const OS = getMobileOperatingSystem();
	const isIOS = OS === 'iOS';
	const coordinates =
		position ??
		(airportCode === AirportCodes.IAH ? IAH_COORDINATES : HOU_COORDINATES);
	const { latitude, longitude } = coordinates;

	if (isIOS) {
		const appleMapsUrl = `http://maps.apple.com/?daddr=${latitude},${longitude}&dirflg=d`;
		window.location.href = appleMapsUrl;
	}

	// Universal cross-platform syntax taken from https://developers.google.com/maps/documentation/urls/get-started
	const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&travelmode=driving`;
	window.open(googleMapsUrl, '_blank');
};
